import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withNamespaces } from 'react-i18next';
import Link from '@material-ui/core/Link';
import Table from 'components/tables';
import {
  loadTopLeads,
} from 'redux/actions/dashboardActions';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableCell from 'components/tables/tableCell';
import TableRow from 'components/tables/tableRow';
import NoResults from 'components/NoResults';
import Pagination from 'components/pagination/Pagination';
import { getDisplayUrl } from 'utils';
import { getTimezoneAndUTCOffset, prepareFilterParams, formatNumber } from 'utils/report';

/* eslint-disable react/prop-types,jsx-a11y/anchor-is-valid */

const TopLeadsTab = (props) => {
  let filterParams = {
    ...prepareFilterParams(props.dashboardParams),
    ...getTimezoneAndUTCOffset(),
  };

  useEffect(() => {
    if (props.isMocked) {
      return;
    }
    filterParams = {
      ...prepareFilterParams(props.dashboardParams),
      ...getTimezoneAndUTCOffset(),
    };
    props.loadTopLeads(filterParams);
  }, [props.dashboardParams]);

  const renderTopLeads = row => (
    <TableRow>
      <TableCell>{row.outlet}</TableCell>
      <TableCell>{row.contact_name}</TableCell>
      <TableCell>
        {row.outlet_url ?
          <Link
            onClick={() => window.open(row.outlet_url, '_blank')}
            component="button"
            variant="body2"
          >
            {getDisplayUrl(row.outlet_url)}
          </Link>
          : 'Unknown'
        }
      </TableCell>
      <TableCell>{row.outlet_type || 'Unknown'}</TableCell>
      <TableCell alignRight>{!Number.isNaN(parseInt(row.potential_reach, 10)) ?
        formatNumber(parseInt(row.potential_reach, 10)) : 'N/A'}
      </TableCell>
    </TableRow>
  );

  const { topLeads } = props;

  return (
    <div className="mb-4 overflow-auto">
      {(!topLeads.loading && topLeads.results.length >= 1) &&
        <>
          <Table className="volt-table" noRadius>
            <TableHead>
              <TableRow>
                <TableCell>Outlet</TableCell>
                <TableCell>Contact name</TableCell>
                <TableCell>Outlet URL</TableCell>
                <TableCell>Outlet type</TableCell>
                <TableCell alignRight>Potential reach</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {topLeads.results.length > 0 &&
                topLeads.results.map(row => renderTopLeads(row))
              }
            </TableBody>
          </Table>
          <Pagination
            items={topLeads}
            onChangePage={props.loadTopLeads}
            params={filterParams}
          />
        </>
      }

      <NoResults
        loading={topLeads.loading}
        results={topLeads.results}
      />
    </div>
  );
};

export default compose(connect(
  state => ({
    isMocked: state.dashboard.isMocked,
    topLeads: state.dashboard.topLeads,
    dashboardParams: state.dashboard.dashboardParams,
  }),
  { loadTopLeads },
), withNamespaces('common'))(TopLeadsTab);
